import { FORM_MODE } from '@/util/common-constant';

export default {
  setLoading(state, loading) {
    state.loading = loading;
  },
  preCreate(state) {
    state.visible = true;
    state.formMode = FORM_MODE.CREATE;
    state.role = {
      roleName: '',
      remark: '',
      roleMenus: [],
    };
  },
  setFormValue(state, { role, formMode }) {
    state.visible = true;
    state.formMode = formMode;
    state.role = {
      ...role,
    };
  },
  getAllSuccess(state, data) {
    state.list = data;
  },
};
